import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import '@pixerito/design-tokens/tokens.css';
import './styles/fonts.css';
import './styles/app.css';
import './styles/dashboard.css';
import './styles/pages.css';
import './styles/print.css';

// Aplica o tema salvo antes do primeiro desenho, para não piscar.
try {
  const saved = localStorage.getItem('pixerito.theme');
  if (saved === 'light' || saved === 'dark') document.documentElement.dataset.theme = saved;
} catch {
  /* sem storage */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
